var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0552 0C13.4806 0.111111 16.1325 1.55556 18.453 3.88889C18.8949 4.33333 19.3369 4.88889 19.6684 5.33333C19.9999 5.77778 19.9999 6.22222 19.6684 6.66667C17.4585 9.44444 14.8065 11.5556 11.0496 12C8.17671 12.3333 5.52477 11.4444 3.20433 9.66667C2.09936 8.77778 1.21538 7.66667 0.331403 6.66667C-8.91257e-05 6.33333 -0.110586 5.88889 0.220905 5.44444C2.20986 2.88889 4.64079 1 7.84522 0.333333C8.5082 0.111111 9.28168 0.111111 10.0552 0ZM10.0552 10.2222C12.3756 10.2222 14.2541 8.33333 14.2541 6.11111C14.2541 3.77778 12.3756 1.88889 10.1657 1.88889C7.73472 1.77778 5.85627 3.77778 5.85627 6.11111C5.85627 8.33333 7.73472 10.2222 10.0552 10.2222ZM7.51372 6.11111C7.51372 7.44444 8.6187 8.66667 10.0552 8.66667C11.3811 8.66667 12.5966 7.55555 12.5966 6.11111C12.5966 4.66667 11.4916 3.55556 10.0552 3.55556C8.6187 3.55556 7.40323 4.66667 7.51372 6.11111Z",
    fill: "#5BB3C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c4ddd604111efd167aebc278f8e3efd5.svg";
export { ForwardRef as ReactComponent };